import classNames from 'classnames';
import { useId } from 'react';

import { paths } from '@farmersdog/constants';
import {
  Button,
  Carousel,
  PageWidth,
  Text,
  useViewport,
  Wave,
} from '@farmersdog/corgi-x';

import styles from './CustomerReviews.css';
import { ReviewCard } from './ReviewCard';
import { reviewsData } from './reviewsData';

export function CustomerReviews() {
  const id = useId();

  const viewport = useViewport();

  return (
    <Wave withBottom withTop>
      <PageWidth>
        <section aria-labelledby={id} className={styles.section}>
          <Text
            variant={viewport.lg ? 'heading-40' : 'heading-28'}
            bold
            color="kale-3"
            as="h2"
            className={styles.center}
            id={id}
          >
            What customers are saying about fresh dog food
          </Text>
          <Carousel className={styles.reviews}>
            {reviewsData.map(data => {
              return <ReviewCard key={data.author} {...data} />;
            })}
          </Carousel>
          <Button
            type="anchor"
            className={classNames(styles.cta, styles.center)}
            href={paths.PATH_SIGNUP}
          >
            Feed Fresh Today
          </Button>
        </section>
      </PageWidth>
    </Wave>
  );
}
